export default __webpack_public_path__ + "static/media/camera.83b367c3.svg";